'use client'
import { ExamBoards } from '@/types/firebase'
import { getExamBoardIcon } from '@/utils/dashboard-utils'
import { AnimatePresence, motion } from 'framer-motion'
import Image from 'next/image'
import React, { FC, useEffect, useState } from 'react'

const examBoards = Object.values(ExamBoards)

// Rotating exam-board logos for the "no course chosen yet" state only.
export const ExamBoardSpinner: FC<{ className?: string }> = ({
  className = 'relative w-20 h-12',
}) => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % examBoards.length)
    }, 1600)

    return () => clearInterval(interval)
  }, [])

  const currentBoard = examBoards[index]

  return (
    <div className={className} style={{ perspective: 600 }}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentBoard}
          initial={{ opacity: 0, rotateY: 90 }}
          animate={{ opacity: 1, rotateY: 0 }}
          exit={{ opacity: 0, rotateY: -90 }}
          transition={{ duration: 0.35 }}
          className="absolute inset-0"
        >
          <Image
            src={getExamBoardIcon(currentBoard)}
            alt={currentBoard}
            fill
            className="object-contain"
          />
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
